import { Surgery } from "../types/patient.types";
import { AuthFetch } from "../hooks/useApi";

// Pedidos salvos são separados por especialidade: o backend só devolve os da especialidade pedida.
const specialtyQuery = (specialty: string) => `?especialidade=${encodeURIComponent(specialty)}`;

export const patientService = {
  getPatients: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    specialty: string,
  ): Promise<{ unique_patients: string[]; patient_orders_count?: Record<string, number> }> =>
    apiFetch(`/patients/${doctorEmail}${specialtyQuery(specialty)}`, { method: "GET" }),

  getSurgeries: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    patientName: string,
    specialty: string,
  ): Promise<{ surgeries: Surgery[] }> =>
    apiFetch(`/patients/${doctorEmail}/${encodeURIComponent(patientName)}${specialtyQuery(specialty)}`, { method: "GET" }),
};
